import {type Command, type MethodBase, toApiFailure} from '@perfectpost/perfect-post-common';

import {perfectPostServiceClient} from '.';

/**
 * `trySend` pour React Query : la valeur en succès, l'`ApiFailure` LEVÉE en refus.
 *
 * Les thunks Redux passaient par `Client.trySend` et `rejectWithValue(failure)`, si bien
 * qu'`unwrap()` levait le refus typé (`statusCode`, `code`, `message` déjà traduit). Une
 * `queryFn` ou une `mutationFn` n'a pas de `rejectWithValue` : elle LÈVE. Lever
 * l'`ApiFailure` elle-même donne le même contrat aux appelants — `error` de `useQuery` /
 * `useMutation` et le rejet de `mutateAsync` sont le refus typé, que `getApiFailure`
 * retrouve tel quel et qu'`ApiFailureAlert` sait afficher avec son action.
 *
 * Implémenté sur `send` + `toApiFailure` (ce que fait `trySend`) plutôt que sur `trySend`,
 * pour que les tests qui mockent `perfectPostServiceClient.send` restent valables.
 */
export async function sendOrThrow<M extends MethodBase, T>(command: Command<M, T>): Promise<T> {
  try {
    return await perfectPostServiceClient.send(command);
  } catch (error: unknown) {
    throw await toApiFailure(error);
  }
}
